<template>
	<el-row>
		<li style="font-size: 20px;">{{list ? '修改文章' : '添加文章'}}</li>
		<el-form ref="info" :model="info" label-position="right" label-width="90px">
			<el-form-item>

			</el-form-item>
			<el-form-item label="文章名称:" prop="title" :rules="[{
           required: true, message: '请输入文章名称', trigger: 'blur'}]">
				<el-input v-model="info.title"></el-input>
			</el-form-item>
			<el-form-item label="描述:" prop="content" :rules="[{
           required: true, message: '请输入描述', trigger: 'blur'}]">
				<wangeditor v-model="info.content" />
			</el-form-item>
			<el-form-item>
				<el-button @click="queren" type="primary">确认</el-button>
			</el-form-item>
		</el-form>
	</el-row>
</template>

<script>
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	export default {
		components: {
			wangeditor,
		},
		data() {
			return {
				info: {
					title: "",
					content: '',
					id: ''
				},
				list: {}
			}
		},
		methods: {
			queren() {
				this.$refs.info.validate((vai) => {
					if (vai) {
						if (this.list) {
							this.$http.post("/api/course/ClrArticleConteoller/addArticle", {
								id: this.info.id,
								title: this.info.title,
								content: this.info.content,
								articleLevelId: this.$route.query.articleId
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.$router.push('./article')
								}
								console.log(res.data.data);
							})
						} else {
							this.$http.post("/api/course/ClrArticleConteoller/addArticle", {
								title: this.info.title,
								content: this.info.content,
								articleLevelId: this.$route.query.articleId
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.$router.push('./article')
								}
								console.log(res.data.data);
							})
						}

					}
				})
			},
			getInfo() {
				this.$http.get("/api/course/ClrArticleConteoller/selectArticle?articleId=" + this.$route.query
					.articleId, {}).then(res => {
					console.log();
					this.list = res.data.data[0]
					if (res.data.data[0]) {
						let list = res.data.data[0]
						this.info.title = list.title
						this.info.content = list.content
						this.info.id = list.id
					}
				})
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">

</style>
